export default "__VITE_ASSET__BeH9DjDR__"